export enum StockTranslations {
  IN_STOCK = 'trans__configurator__stock_section__status_in_stock',
  OUT_OF_STOCK = 'trans__configurator__stock_section__status_out_of_stock',
  PRE_ORDER_STOCK = 'trans__configurator__stock_section__status_pre_order_now_flag_with_stock',
  PRE_ORDER_NO_STOCK = 'trans__configurator__stock_section__status_pre_order_now_flag_no_stock',
}
